import React from 'react';

class AudioErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('AudioPlayer error caught by boundary:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-between text-xs text-muted-foreground" data-testid="audio-boundary-error">
          <span>Audio player error</span>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="text-primary hover:text-[#7A9186] transition-colors"
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AudioErrorBoundary;
